module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Regular.99f64f62.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Regular.eot
// module id = 924
// module chunks = 0